export enum DownloadTrackingEventTypes {
    STARTED = 'downloadStarted',
    COMPLETED = 'downloadCompleted',
    ABORTED = 'downloadAborted'
}

interface DownloadTrackingBaseEvent {
  type: DownloadTrackingEventTypes,
  fileName: string,
  fileType: string,
  fileSize: number,
  correlationId: string
}

export interface DownloadTrackingStartedEvent extends DownloadTrackingBaseEvent {
}

export interface DownloadTrackingCompletedEvent extends DownloadTrackingBaseEvent {
  avgSpeed: number,
  downlink?: number,
  effectiveType?: string,
  duration: number,
  cachedSizeCf: number,
  cachedSizeEdge: number
}

export interface DownloadTrackingAbortedEvent extends DownloadTrackingBaseEvent {
  downloadedSize: number,
  duration: number
}

export type DownloadTrackingEvents = DownloadTrackingStartedEvent | DownloadTrackingAbortedEvent | DownloadTrackingCompletedEvent
